import { KeyRound, MonitorSmartphone, ShieldCheck, Users } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';

const tabs = [
  { to: '/settings/security', label: 'Security', icon: ShieldCheck },
  { to: '/settings/sessions', label: 'Sessions', icon: MonitorSmartphone },
  { to: '/settings/team', label: 'Team', icon: Users },
  { to: '/settings/api-tokens', label: 'API Tokens', icon: KeyRound },
];

export function SettingsLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Account Settings</h1>
        <p className="text-sm text-muted-foreground">
          Manage your password, two-factor authentication, sessions, and API access.
        </p>
      </div>

      <nav className="scrollbar-none flex gap-1 overflow-x-auto border-b border-border pb-px">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm transition-colors',
                isActive
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )
            }
          >
            <tab.icon className="size-4" />
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
